// @ts-ignore
import * as GeometryUtil from "leaflet-geometryutil";
export const getPointByDistance = (point, distanceInMeters, directionInDegrees) => {
    const result = GeometryUtil.destination(point, directionInDegrees, distanceInMeters);
    return {
        lat: result.lat,
        lng: result.lng,
    };
};
